import { combineReducers } from '@reduxjs/toolkit';
import userAnswers from './userAnswers/userAnswers.slice';
import questionnaire from './questionnaire/questionnaire.slice';
import ui from './ui/ui.slice';
import allDisputes from './allDisputes/allDisputes.slice';
import appConfig from './appConfig/appConfig.slice';
import caseDetails from './cases/cases.slice';
import globalAuth from './globalAuth/globalAuth.slice';
import cancelDispute from './cancelDispute/cancelDispute.slice';
import transactionEligible from './transactionEligible/transactionEligible.slice';
import featureFlags from './featureFlags/featureFlags.slice';
import transactionData from './transactionData/transactionData.slice';
import mfeConfig from './mfeConfig/mfeConfig.slice';
import additionalInfo from './additionalInfo/additionalInfo.slice';
export default combineReducers({
    ui: ui,
    userAnswers: userAnswers,
    allDisputes: allDisputes,
    appConfig: appConfig,
    questionnaire: questionnaire,
    caseDetails: caseDetails,
    globalAuth: globalAuth,
    cancelDispute: cancelDispute,
    transactionEligible: transactionEligible,
    featureFlags: featureFlags,
    transactionData: transactionData,
    mfeConfig: mfeConfig,
    additionalInfo: additionalInfo
});
//# sourceMappingURL=rootReducer.js.map